__turbopack_context__.v({
  "active": "NavLinkItem-module-scss-module__4TrVVa__active",
  "activeDot": "NavLinkItem-module-scss-module__4TrVVa__activeDot",
  "navLink": "NavLinkItem-module-scss-module__4TrVVa__navLink",
  "navLinkRoot": "NavLinkItem-module-scss-module__4TrVVa__navLinkRoot",
});
